
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import store from '@/store/index';
import {
    isUndef,
} from '@/lib/utils';

/**
 * 使用v-model绑定数据
 *
 * @input(index) 点击事件，其中index是navigations的索引
 */
@Component({
    name: 'SlideNav',
})
export default class SlideNav extends Vue {
    /** 所有导航内容，需要包含value和text */
    @Prop({ required: true, type: Array, default() { return []; } }) public navigations!: ValueText1[];
    /** 所传入的值 */
    @Prop({ type: [ String, Number ] }) public value!: string | number;
    /** 容器样式类 */
    @Prop({ type: [ Object, Array ] }) public containerClass!: object;
    /** 包裹容器类 */
    @Prop({ type: [ Object, Array ] }) public wrapClass!: object;
    /** item样式类 */
    @Prop({ type: [ Object, Array ] }) public itemClass!: object;
    /** indicator样式类 */
    @Prop({ type: [ Object, Array ] }) public indicatorClass!: object;
    /** 内容位置，可以是 left/center/right */
    @Prop({ type: String, default: 'center' }) public contentPosition!: string;
    /** 是否触发scrollIntoView方法 */
    @Prop({ type: Boolean, default: false }) public isScrollIntoView!: boolean;
    /** 是否显示indicator */
    @Prop({ type: Boolean, default: true }) public indicatorVisible!: boolean;

    /**
     * 处理value，暂时使用scrollIntoView，让tab进入到parent中
     */
    @Watch('value')
    public onChangeValue(val: string | number) {
        if (this.isScrollIntoView) {
            const el = this.$refs[val] as HTMLElement | undefined;
            if (el && el.scrollIntoView) {
                el.scrollIntoView();
            }
        }
    }

    @Watch('isScrollIntoView')
    public onIsScrollIntoViewChanged(val: boolean) {
        if (val) {
            const el = this.$refs[this.value] as HTMLElement | undefined;
            if (el && el.scrollIntoView) {
                el.scrollIntoView();
            }
        }
    }

    /**
     * 移动的距离
     */
    public get percentage() {
        if (isUndef(this.navigations) || this.navigations.length === 0) {
            return 0;
        } else {
            return ((1 / this.navigations.length) * 100).toFixed(2);
        }
    }
    /**
     * 所选择的index
     */
    public get selectedIndex() {
        let result = 0;
        this.navigations.forEach((navigation, index) => {
            if (navigation.value === this.value) {
                result = index;
            }
        });
        return result;
    }

    /**
     * 点击选项
     */
    public onClick(value: string | number) {
        this.$emit('input', value);
    }
    public mounted() {
        if (this.isScrollIntoView) {
            const el = this.$refs[this.value] as HTMLElement | undefined;
            if (el && el.scrollIntoView) {
                el.scrollIntoView();
            }
        }
    }
}
